import { useMemo } from 'react';
import { useObserver } from 'mobx-react-lite';
import { ApolloError, useQuery } from '@apollo/client';

import { GetRecommendedProductsDocument } from 'src/gql/graphql';
import { Product, parseProduct } from 'src/utils/helpers/product';
import useUser from 'hooks/use-user';

type UseRecommendedProductsParams = {
  dispensaryId: string;
};

type UseRecommendedProductsReturn = {
  error?: ApolloError;
  loading: boolean;
  products: Product[];
};

export function useRecommendedProducts({ dispensaryId }: UseRecommendedProductsParams): UseRecommendedProductsReturn {
  const user = useUser();
  const isLoggedIn = useObserver(() => user.isLoggedIn);
  const { data, loading, error } = useQuery(GetRecommendedProductsDocument, {
    fetchPolicy: `network-only`,
    skip: !dispensaryId || !isLoggedIn,
    variables: {
      dispensaryId,
    },
  });

  const normalizedProducts = useMemo(
    () => data?.getRecommendedProducts.map((item): Product => parseProduct(item)) ?? [],
    [data?.getRecommendedProducts]
  );

  return {
    products: normalizedProducts,
    loading,
    error,
  };
}
